import React from "react";

import TableWrapper from "../../../tableWrapper/tableWrapper.component";

import { StyledWrapper } from "./newPage.style";
import Container from "../form/container";

const NewPage = () => {
  return (
    <StyledWrapper>
      <Container />
      <div className="content-column">
        <TableWrapper name="companyInvoices" />
      </div>
    </StyledWrapper>
  );
};

export default NewPage;
